export default {
    isDarkModeEnabled: false,
    isMonochromeModeEnabled: false,
    isSearchbarActive: false,
    hasTask: false,
    currentLocation: currentLocation(),
    init() {
        let firstTime = true;

        this.isDarkModeEnabled = Alpine.$persist(false).as("_x_darkMode_on");
        this.isMonochromeModeEnabled = Alpine.$persist(false).as("_x_monoChrome_on");

        Alpine.effect(() => {
            this.isDarkModeEnabled
                ? document.documentElement.classList.add("dark")
                : document.documentElement.classList.remove("dark");

            if (this.isDarkModeEnabled) {

                let linkNode = document.querySelector('link[href*="atom-one-light.min.css"]');

                if (linkNode !== undefined && linkNode !== null) {
                    linkNode.remove();
                }

                let link = document.createElement('link');
                link.href = "css/hljs/atom-one-dark.min.css";
                link.rel = "stylesheet";

                document.head.appendChild(link);
            } else {
                let linkNode = document.querySelector('link[href*="atom-one-dark.min.css"]');

                if (linkNode !== undefined && linkNode !== null) {
                    linkNode.remove();
                }

                let link = document.createElement('link');
                link.href = "css/hljs/atom-one-light.min.css";
                link.rel = "stylesheet";

                document.head.appendChild(link);
            }
        });

        Alpine.effect(() => {
            this.isMonochromeModeEnabled
                ? document.body.classList.add("is-monochrome")
                : document.body.classList.remove("is-monochrome");
        });

        Alpine.effect(() => {
            if (Alpine.store("breakpoints").name && !firstTime) {
                this.isRightSidebarExpanded = false;
            }
        });

        Alpine.effect(() => {
            if (Alpine.store("breakpoints").smAndUp) this.isSearchbarActive = false;
        });

        firstTime = false;
    },

    documentBody: {
        ["@load.window"]() {
            const preloader = document.querySelector(".app-preloader");
            if (!preloader) return;
            setTimeout(() => {
                preloader.classList.add(
                    "animate-[cubic-bezier(0.4,0,0.2,1)_fade-out_500ms_forwards]"
                );
                setTimeout(() => preloader.remove(), 1000);
            }, 150);
        },
    },
};

function currentLocation() {
    return [location.protocol, "//", location.host, location.pathname].join("");
}
